import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function CampaignIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_12372_107403" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_12372_107403)"><path d="M30.4154 21.2503V18.7503H36.6654V21.2503H30.4154ZM32.4987 33.3337L27.457 29.5837L28.957 27.5837L33.9987 31.3337L32.4987 33.3337ZM29.082 12.3753L27.582 10.3753L32.4987 6.66699L33.9987 8.66699L29.082 12.3753ZM8.7487 31.667V25.0003H5.83203C5.14453 25.0003 4.55606 24.7555 4.06661 24.2657C3.57689 23.7763 3.33203 23.1878 3.33203 22.5003V17.5003C3.33203 16.8128 3.57689 16.2242 4.06661 15.7345C4.55606 15.245 5.14453 15.0003 5.83203 15.0003H13.332L21.6654 10.0003V30.0003L13.332 25.0003H11.2487V31.667H8.7487ZM19.1654 25.5837V14.417L13.9987 17.5003H5.83203V22.5003H13.9987L19.1654 25.5837ZM23.332 25.5837V14.417C24.082 15.0837 24.6862 15.8962 25.1445 16.8545C25.6029 17.8128 25.832 18.8614 25.832 20.0003C25.832 21.1392 25.6029 22.1878 25.1445 23.1462C24.6862 24.1045 24.082 24.917 23.332 25.5837Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}